/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Usage_Status_SuspendedInputs */



/**
* | output |
* | --- |
* | "suspended, not billed" |
*
* @param {Admin_Export_Usage_Status_SuspendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_status_suspended = /** @type {((inputs?: Admin_Export_Usage_Status_SuspendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_Status_SuspendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("gesperrt, nicht abgerechnet")
	return /** @type {LocalizedString} */ ("suspended, not billed")
});